import { Theme } from '@mui/material';

import { ColorExtractFn } from '@/types/components/common';

export type ModalIndicatorType =
  | 'primaryWarning'
  | 'primarySuccess'
  | 'primaryInformation'
  | 'primaryError'
  | 'secondarySuccess'
  | 'secondaryInformation'
  | 'secondaryError';

type ModalIndicatorVariantConfig = {
  backgroundColor: ColorExtractFn;
  iconColor: ColorExtractFn;
};

export const MODAL_INDICATOR_VARIANTS: Record<
  ModalIndicatorType,
  ModalIndicatorVariantConfig
> = {
  primaryWarning: {
    backgroundColor: (theme: Theme) => theme.palette.semantic.warning[400],
    iconColor: (theme: Theme) => theme.palette.neutral.min,
  },
  primarySuccess: {
    backgroundColor: (theme: Theme) => theme.palette.semantic.success[400],
    iconColor: (theme: Theme) => theme.palette.neutral.min,
  },
  primaryInformation: {
    backgroundColor: (theme: Theme) => theme.palette.primaries[400],
    iconColor: (theme: Theme) => theme.palette.neutral.min,
  },
  primaryError: {
    backgroundColor: (theme: Theme) => theme.palette.semantic.error[400],
    iconColor: (theme: Theme) => theme.palette.neutral.min,
  },
  secondarySuccess: {
    backgroundColor: (theme: Theme) => theme.palette.semantic.success[100],
    iconColor: (theme: Theme) => theme.palette.semantic.success[400],
  },
  secondaryInformation: {
    backgroundColor: (theme: Theme) => theme.palette.primaries[200],
    iconColor: (theme: Theme) => theme.palette.primaries[400],
  },
  secondaryError: {
    backgroundColor: (theme: Theme) => theme.palette.semantic.error[200],
    iconColor: (theme: Theme) => theme.palette.semantic.error[500],
  },
};

export const MODAL_INDICATOR_BACKGROUND_SIZES = {
  S: 48,
  L: 116,
};
